import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React, { PureComponent } from 'react';
import { event } from '@alilc/lowcode-engine';
import './index.less';
var SetterVariable = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(SetterVariable, _PureComponent);
  function SetterVariable() {
    return _PureComponent.apply(this, arguments) || this;
  }
  SetterVariable.show = function show(_ref) {
    var field = _ref.prop;
    event.emit('variableBindDialog.openDialog', {
      field: field
    });
  };
  var _proto = SetterVariable.prototype;
  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("div", {
      className: "lowcode-setter-variable"
    }, "Hello LowcodeSetterVariable");
  };
  return SetterVariable;
}(PureComponent);
SetterVariable.displayName = 'SetterVariable';
SetterVariable.isPopup = true;
export { SetterVariable as default };